﻿import CustomElementFactory from "./custom.element.factory.js";

export default class TechnoDialog extends CustomElementFactory {
    constructor() {
        super();
    
        // Hier initialisieren Sie die erforderlichen Eigenschaften oder Konfigurationen.
        // Dies wird aufgerufen, wenn Ihr Element erstellt wird.
        // Hier können Sie auch Schatten-DOM, Event-Listener usw. einrichten.
      }
    
      connectedCallback() {
  
        // Wird aufgerufen, wenn Ihr Element in das Dokument eingefügt wird.
        // Fügen Sie hier Logik hinzu, die ausgeführt werden soll, wenn das Element im DOM ist.
        this.pushListener({event: "click", element: this, action: this.eventListener.bind(this)})
      }
    
    
      attributeChangedCallback(name, oldValue, newValue) {
        // Wird aufgerufen, wenn eine beobachtete Attributänderung festgestellt wird.
        // Überwachen Sie Attribute mit observedAttributes().
        // Führen Sie hier entsprechende Aktionen aus, wenn sich Attribute ändern.
      }
    
      static get observedAttributes() {
        // Geben Sie hier die Namen der Attribute an, die Sie überwachen möchten.
        // Wenn sich eines dieser Attribute ändert, wird attributeChangedCallback aufgerufen.
        return ['custom-attribute'];
      }
        
      // Fügen Sie benutzerdefinierte Methoden für Ihr Element hinzu, falls erforderlich.
      eventListener(e) {
  
        // on ok btn clicked
        if(e.target.matches('[data-basket-selected-btn]')) {
            // this.onOkButtonClicked();
        }
  
  
      }
  
}